import { Col, Form, Input, Radio, Row } from "antd"

const approveOrReject = [{ id: 1, label: 'Approve' }, { id: 0, label: 'Reject' }]

const ConfirmationModal = () => {

    return (
        <Row gutter={5} justify={'start'}>
            <Col xxl={6} lg={6} md={6}>
                <Form.Item name='approveOrReject' labelCol={{ span: 6 }} >
                    <Radio.Group>
                        {approveOrReject.map(({ id, label }) => (
                            <Radio value={id} key={id}>
                                {label}
                            </Radio>
                        ))}
                    </Radio.Group>
                </Form.Item>
            </Col>
            <Col xxl={18} md={18} lg={18}>
                <Form.Item name={'remarks'} label='Remark' labelCol={{ span: 24 }}>
                    <Input.TextArea cols={8} rows={4}></Input.TextArea>
                </Form.Item>
            </Col>
        </Row>
    )
}

export default ConfirmationModal